<script setup>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import TabBar from './components/TabBar.vue'
import VConsole from 'vconsole'

const vConsole = new VConsole();
const route = useRoute()

// 计算是否显示TabBar
const showTabBar = computed(() => {
  // 定义需要显示TabBar的路由路径
  const visibleRoutes = ['/workbench', '/customer', '/live']
  // 检查当前路由路径是否在可见路由列表中
  return visibleRoutes.includes(route.path)
})
</script>

<template>
  <div class="app-container">
    <router-view />
    <TabBar v-if="showTabBar" />
  </div>
</template>

<style>
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
